import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './ErrorMessage.module.css';

interface Props {
  id?: string;
  children: ReactNode;
  background?: 'onDark';
}
const ErrorMessage = (props: Props) => {
  return (
    <div
      id={props.id}
      className={clsx(
        styles.container,
        props.background === 'onDark' ? styles.onDarkBackground : undefined,
      )}
    >
      {props.children}
    </div>
  );
};

export default ErrorMessage;
